import Swiper, {
  Lazy, Autoplay,
} from 'swiper/core';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// configure Swiper to use modules
Swiper.use([Lazy, Autoplay]);

export default class SwiperInstagram {
  constructor(swiperEl) {
    this.dom = {
      swiper: swiperEl,
      swiperWrapper: swiperEl.querySelector('.swiper-wrapper'),
    };

    this.data = {
      swiperConfig: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        grabCursor: true,
        initialSlide: 0,
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
          992: {
            spaceBetween: 30,
          },
          1200: {
            spaceBetween: 40,
          },
        },
        // Disable preloading of all images
        // preloadImages: false,
        // Enable lazy loading
        // lazy: {
        //   checkInView: true,
        //   loadPrevNext: true,
        // },
      },
      direction: swiperEl.dir === 'rtl' ? 'right' : 'left',
      tl: undefined,
    };

    this.components = {
      swiperInstance: null,
    };

    this.mount();
  }

  mount() {
    this.animate();
    this.components.swiperInstance = new Swiper(this.dom.swiper, this.data.swiperConfig);
    this.components.swiperInstance.on('touchStart', () => {
      if (this.data.tl) {
        this.data.tl.kill();
        this.data.tl = undefined;
      }
    });
  }

  animate() {
    this.data.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.dom.swiperWrapper,
        scrub: 1,
      },
    })
      .to(this.dom.swiperWrapper, {
        x: (this.data.direction === 'right' ? '+=100' : '-=100'),
      });
  }
}
